import { Button } from "@/lib/components/Button/Button";
import { ReactNode } from "react";

function GradientPromptTextarea({
  value,
  onChange,
  placeholder,
  actionsChildren,
  submitLabel,
  onSubmit,
  source,
  overlay,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  actionsChildren: ReactNode;
  submitLabel: ReactNode;
  onSubmit?: () => void;
  source: "ANIMATION" | "EDIT_IMAGE";
  overlay?: ReactNode;
}) {
  const colorScheme = source === "ANIMATION" ? "primary" : "tertiary";
  const gradientBackground =
    colorScheme === "tertiary"
      ? "linear-gradient(white, white) padding-box, linear-gradient(to bottom right, var(--color-tertiary-400), var(--color-tertiary-400)) border-box"
      : "linear-gradient(white, white) padding-box, linear-gradient(to bottom right, var(--color-primary-400), var(--color-secondary-400)) border-box";

  return (
    <div
      className="relative flex w-full flex-col rounded-xl border border-transparent px-6 py-4"
      style={{ background: gradientBackground }}
    >
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-32 w-full resize-none bg-transparent text-base leading-6.5 text-text-primary placeholder:text-muted-foreground focus:outline-none"
      />
      <div className="mt-2 flex items-center gap-4 pt-2">
        {actionsChildren}
        <div className="ml-auto flex items-center gap-2">
          <Button
            size="sm"
            variant={colorScheme === "tertiary" ? "tertiary" : "default"}
            onClick={onSubmit}
            disabled={!value.trim()}
          >
            {submitLabel}
          </Button>
        </div>
      </div>
      {overlay}
    </div>
  );
}

export default GradientPromptTextarea;
